import { CampaignForm } from 'common/pages/campaign/CampaignForm.tsx'

export const CampaignFormAgency = (props: any) => <CampaignForm {...props} mode={props.mode} agency/>